import { Paper, alpha, styled } from "@mui/material";
import { cardName } from "../classes.js";
const Root = styled(Paper, {
  name: cardName,
  overridesResolver: (_, styles) => styles.root,
  shouldForwardProp: (propName) => propName !== "ownerState",
  slot: "Root"
})(({ theme, ownerState }) => {
  const elevation = ownerState.elevation ?? 1;
  const activeShadowColor = (theme.vars ?? theme).palette.primary.main;
  const activeShadowElevation = (theme.vars ?? theme).shadows[elevation];
  const activeShadow = elevation ? `inset 0 0 0 var(--card-hover-state-border-width) ${activeShadowColor}, ${activeShadowElevation}` : `inset 0 0 0 var(--card-hover-state-border-width) ${activeShadowColor}`;
  const hoverShadowColor = theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.12)` : alpha(theme.palette.primary.main, 0.12);
  const hoverShadowElevation = (theme.vars ?? theme).shadows[elevation];
  const hoverShadow = elevation ? `inset 0 0 0 var(--card-hover-state-border-width) ${hoverShadowColor} , ${hoverShadowElevation}` : `inset 0 0 0 var(--card-hover-state-border-width) ${hoverShadowColor}`;
  return {
    display: "flex",
    position: "relative",
    backgroundColor: (theme.vars ?? theme).palette.background.default,
    borderRadius: "var(--card-border-radius)",
    color: (theme.vars ?? theme).palette.text.primary,
    overflow: "hidden",
    padding: "var(--card-content-padding-y) var(--card-content-padding-x)",
    ...ownerState.active ? { boxShadow: activeShadow } : {},
    ...ownerState.width ? { width: ownerState.width } : {},
    "&:hover": {
      boxShadow: ownerState.active ? activeShadow : hoverShadow
    },
    "& > * + *": {
      marginLeft: theme.spacing(1)
    }
  };
});
export {
  Root
};
//# sourceMappingURL=Root.js.map
